import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AccordionOpenItemsState {
    openItems: string[];
}

const initialState: AccordionOpenItemsState = {
    openItems: [],
};

export const accordionOpenItemsSlice = createSlice({
    name: 'accordionOpenItems',
    initialState,
    reducers: {
        setAccordionOpenItems: (state, action: PayloadAction<string[]>) => {
            state.openItems = action.payload;
        },
    },
});

export const { setAccordionOpenItems } = accordionOpenItemsSlice.actions;

export default accordionOpenItemsSlice.reducer;
